import { render } from "./MatMeny.vue?vue&type=template&id=4ff0ae03&scoped=true"
import script from "./MatMeny.vue?vue&type=script&lang=js"
export * from "./MatMeny.vue?vue&type=script&lang=js"

import "./MatMeny.vue?vue&type=style&index=0&id=4ff0ae03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff0ae03"]])

export default __exports__